const loadGoogleMapsApiPack = require('load-google-maps-api');

const Error_common = "Map Error : ";
const Error_googleMapsApiMissing = Error_common + "The googleMapsApi property is missing";
const Error_mapMissing = Error_common + "The map property is missing";

class Gmap {
  constructor(key, center, options = {}) {
    // Required
    this.key = key;
    this.center = center;

    // Options / Default values
    let defaultOptions = {
      center: this.center,
      zoom: 14,
			scrollwheel: false,
      styles: []
    };

    this.options = Object.assign(defaultOptions, options);

    // Others
    this.googleMapsApi;
    this.map;
  }

  loadGoogleMapsApi() {
    return loadGoogleMapsApiPack({ key: this.key });
  }

  createMap(mapElement) {
    this.testGoogleMapsApi();
    this.map = new this.googleMapsApi.Map(mapElement, this.options);
    return this.map;
  }

  addMarker(markerOptionsParams = {}){
    this.testGoogleMapsApi();
    this.testMap();
    let defaultMarkerOptions = {
      position: this.center,
      map: this.map,
    };
    let markerOptions = Object.assign(defaultMarkerOptions,markerOptionsParams);
    return new this.googleMapsApi.Marker(markerOptions);
  }

  // Tests
  testGoogleMapsApi(){
    if (!this.googleMapsApi){
      console.error(Error_googleMapsApiMissing);
      throw new Error(Error_googleMapsApiMissing);
    }
  }
  
  testMap(){
    if (!this.map){
      console.error(Error_mapMissing);
      throw new Error(Error_mapMissing);
    }
  }
}

export { Gmap };